var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(2573 -12622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-stars",
    "data-name": "Icon material-stars",
    d: "M12.99,3A10,10,0,1,0,23,13,10,10,0,0,0,12.99,3Z",
    transform: "translate(-2576 12619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-stars-2",
    "data-name": "Icon material-stars",
    d: "M12.99,3A10,10,0,1,0,23,13,10,10,0,0,0,12.99,3Zm4.24,16L13,16.45,8.77,19l1.12-4.81L6.16,10.96l4.92-.42L13,6l1.92,4.53,4.92.42-3.73,3.23L17.23,19Z",
    transform: "translate(-2576 12619)",
    fill: "#cc7b06"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d1d75a8e029416409b13d4f18b857d5c.svg";
export { ForwardRef as ReactComponent };